require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-gift-from-ball-state-financial-will-boost-universitys-financial-literacy.json") })
        }
      }, "path---es-articles-gift-from-ball-state-financial-will-boost-universitys-financial-literacy");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-gift-from-ball-state-financial-will-boost-universitys-financial-literacy!./.cache/json/es-articles-gift-from-ball-state-financial-will-boost-universitys-financial-literacy.json
// module id = 2160
// module chunks = 231608221292675